export default __webpack_public_path__ + "img/bOaUppck.f4226d36.svg";